import perfilEmpresarilService from '../services/perfilEmpresarial.js';

export const usePerfilEmpresarial = () => {

    const getData = (usuario) => perfilEmpresarilService.getData(usuario);
    const getActual = (usuario, language) => perfilEmpresarilService.getActual(usuario, language);

    return { getData, getActual };
}